import { useMemo } from "react";
import { CountQuery, CountQueryVariables, SearchFilter } from "gql/graphql";
import { useQuery } from "@apollo/client";
import COUNT_QUERY from "./_networking/count";
import { useAuth } from "modules/providers/auth-provider";

const useCount = (searchFilters: SearchFilter[]) => {
  const { isLoggedIn } = useAuth();
  const { data, loading } = useQuery<CountQuery, CountQueryVariables>(
    COUNT_QUERY,
    {
      variables: {
        searchFilterList: searchFilters,
      },
      skip: !isLoggedIn || searchFilters.length === 0,
    },
  );

  const count = useMemo(() => {
    if (!data) return 0;
    return data.count;
  }, [data]);

  return {
    count,
    loading,
  };
};

export default useCount;
